__turbopack_context__.v({
  "section": "catalog-faq-module-scss-module__8lH-gq__section",
  "title": "catalog-faq-module-scss-module__8lH-gq__title",
});
